import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { map, Observable, take, tap } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { DocksModel } from 'src/app/models/DocksModel';
import { QueueTableModel } from 'src/app/models/QueueTable.Model';
import { TimeTableInterface, TimeTableModel } from 'src/app/models/TimeTableModel';
import { QueuesService } from 'src/app/services/queues/queues.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filas',
  templateUrl: './filas.component.html',
  styleUrls: ['./filas.component.css']
})
export class FilasComponent implements OnInit {
  constructor(private http: HttpClient, private queuesService: QueuesService) { }

  expeditionDocks$?: Observable<DocksModel[]>
  docksDescription$?: Observable<DocksModel[]>;
  filteredTrips$?: Observable<QueueTableModel[]>;
  availableTrips$?: Observable<TimeTableInterface[]>
  showTable: boolean = false
  showForm: boolean = false
  dockNumberToQueue: number = 0
  trips: any[] = []

  //form
  dockNumber: number = 0;
  tripNumber: number = 0;
  dockDescription$?: Observable<string>;
  tripDetails$?: Observable<TimeTableInterface>;

  ngOnInit() {
    this.docksDescription$ = this.queuesService.getDockDetails();
    this.availableTrips$ = this.queuesService.listAvailableTrips();
    this.expeditionDocks$ = this.queuesService.getDockDetails();
  }

  listAvailableTrips(): Observable<TimeTableModel[]> {
    return this.http.get<TimeTableModel[]>(`${environment.apiLink}/Queues/GetTrips/?filter=Unlinked`, httpOptions)
      .pipe(
        tap((response) => console.log(response)),
        take(1))
  }

  onSubmit() {
    if (this.dockNumber > 0 && this.tripNumber > 0) {
      this.queuesService.linkTripOnDock(this.dockNumber, this.tripNumber)
        .subscribe({
          next: (response) => {
            console.log("Success: ", response);
            alert("Viagem vinculada a doca e adicionada a fila com sucesso."),
              this.refreshTables()
          },
          error: (error) => {
            console.error("Error: ", error);
            alert("Falha durante a operação, verifique os valores registrados!");
          }
        })
    } else alert("Valores incorretos!")
  }

  onDockNumberChange() {
    if (this.dockNumber > 0) {
      this.dockDescription$ = this.queuesService.getDockDescriptionsById(this.dockNumber);
    }
  }

  onTripNumberChange() {
    if (this.tripNumber > 0) {
      this.tripDetails$ = this.queuesService.getTripDetailsByNumber(this.tripNumber);
    }
  }

  toggleQueueByDock(dockId: number) {
    this.dockNumberToQueue = dockId;
    this.filteredTrips$ = this.queuesService.listQueueByDockNumber(this.dockNumberToQueue)
      .pipe(
        map((response) => response.tripsInQueue)
      )
  }

  toggleForm(trip?: number) {
    if (trip) {
      this.tripNumber = trip
      this.onTripNumberChange()
    }

    this.showForm = !this.showForm
  }

  toggleTable() {
    this.showTable = !this.showTable;
    if (!this.showTable) {
      this.showForm = false;
    }
  }

  moveUp(currentTrip: QueueTableModel, trips: QueueTableModel[]) {
    const currentIndex = trips.findIndex(trip => trip.queueOrder === currentTrip.queueOrder);
    const previousIndex = currentIndex - 1;

    const previousTrip = trips[previousIndex];

    console.log("Viagem atual:", currentTrip); // Log da viagem atual
    if (previousTrip) {
      console.log("Viagem anterior:", previousTrip); // Log da viagem anterior

      // Chame o serviço para mover a viagem atual para baixo
      this.queuesService.updateQueueOrder(currentTrip.doca, currentTrip.viagem, 'up').subscribe({
        next: () => {
          console.log('Ordem atualizada com sucesso.');
          this.refreshTables(); // Chama o método para recarregar a fila
        },
        error: (error) => {
          console.error('Erro ao atualizar a ordem da fila:', error);
        }
      });
    } else {
      console.log("Não há próxima viagem para mover.");
    }
  }

  moveDown(currentTrip: QueueTableModel, trips: QueueTableModel[]) {
    const currentIndex = trips.findIndex(trip => trip.queueOrder === currentTrip.queueOrder);
    const nextIndex = currentIndex + 1;

    const nextTrip = trips[nextIndex];

    console.log("Viagem atual:", currentTrip); // Log da viagem atual
    if (nextTrip) {
      console.log("Próxima viagem:", nextTrip); // Log da próxima viagem

      // Chame o serviço para mover a viagem atual para baixo
      this.queuesService.updateQueueOrder(currentTrip.doca, currentTrip.viagem, 'down').subscribe({
        next: () => {
          console.log('Ordem atualizada com sucesso.');
          this.refreshTables(); // Chama o método para recarregar a fila
        },
        error: (error) => {
          console.error('Erro ao atualizar a ordem da fila:', error);
        }
      });
    } else {
      console.log("Não há próxima viagem para mover.");
    }
  }

  deleteTripById(tripNumber: number): void {
    this.queuesService.deleteTripFromDock(tripNumber).subscribe({
      next: () => {
        this.trips = this.trips.filter(trip => trip.viagem !== tripNumber); // Remove a viagem deletada da lista

        if (this.dockNumberToQueue) {
          this.queuesService.recalculateQueueOrder(this.dockNumberToQueue).subscribe({
            next: () => {
              console.log("Ordem da fila recalculada com sucesso para DockId: ", this.dockNumberToQueue);
              this.refreshTables();
              alert("Viagem deletada. Fila reordenada!")
            },
            error: (err) => {
              console.error("Erro ao recalcular a ordem da fila:", err);
            }
          });
        }
      },
      error: (err) => {
        console.error("Erro ao deletar viagem:", err);
      }
    });
    console.log("Viagem deletada da fila, número da viagem: ", tripNumber);
  }


  refreshTables() {
    this.toggleQueueByDock(this.dockNumberToQueue);
    this.availableTrips$ = this.queuesService.listAvailableTrips();
  }
}






